import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { iifFreeOrCustomLicenseValid } from '@core/helpers/license/license.helper';
import { LicenseService } from '@core/services/license/license.service';
import { RoutePath } from '@shared/route-path.enum';
import { map } from 'rxjs';

export const freeOrCustomLicenseActiveGuard = (_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) => {
	const router = inject(Router);
	const licenseService = inject(LicenseService);
	return licenseService.license$.pipe(
		map((license) => {
			if (iifFreeOrCustomLicenseValid(license, true)) {
				return true;
			}
			router.navigate([RoutePath.INACTIVE_ACCOUNT]);
			return false;
		})
	);
};
